import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
//import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';
import { FollowUpService, CommonService } from '../../../services/index';
import { FollowUpModel, FollowUpStatus, EmployeeModel } from '../../../model/index';
import { empty } from 'rxjs/Observer';

@Component({
    selector: 'follow-up-window',
    templateUrl: './followUpWindow.component.html'
})
export class FollowUpWindowComponent implements OnInit {
    @Output() followUpListGridUpdateEvent = new EventEmitter();
    @ViewChild('singleClientDetails') singleClientDetails;
    private searchTermsEmp = new Subject<string>();

    isLoading: boolean = false;
    showFollowUpForm: boolean = false;
    staname: boolean = false;
    clientPerDet: any[] = [];
    hvcomplaintList: any[] = [];
    soacomplaintList: any[] = [];
    clientFollowDet = {};
    followUpStatusList: any[];
    hvcomplaintCtrl: FormControl;
    soacomplaintCtrl: FormControl;
    hvpotCtrl: FormControl;
    soapotCtrl: FormControl;
    branchCtrl: FormControl;
    branchSmsCtrl: FormControl;
    followUpDateCtrl: FormControl;
    unsoldCtrl: FormControl;
    soldCtrl: FormControl;
    statusCtrl: FormControl;
    haUserCtrl: FormControl;
    toWhomControl: FormControl;
    billDetailCtrl: FormControl;
    freeItemCtrl: FormControl;
    serviceCtrl: FormControl;
    usingMethodCtrl: FormControl;
    testingtypeCtrl: FormControl;
    ratingCtrl: FormControl;
    drConsCtrl: FormControl;
    folTypeCtrl: FormControl;
    communicationTypeCtrl: FormControl;
    summaryStatusCtrl: FormControl;
    hvStatusCtrl: FormControl;
    soaStatusCtrl: FormControl;
    halistCtrl: FormControl;
    hvCtrl: FormControl;
    soaCtrl: FormControl;
    assignToCtrl: FormControl;
    empNameCtrl: FormControl;
    newBranchCtrl: FormControl;
    filteredEmpName: Observable<any[]>;
    empNameList: any[] = [];
    hvpotCusOptList: any[];
    soapotCusOptList: any[];
    branchList: any[] = [];
    branch_chk_name: any[] = [];
    user_branch_name: any = "";
    userid: any = "";
    smsBranch: any[] = [];
    _followUpDet: any[] = [];
    userList: any[];
    assignToList: any[];
    filteredAssignToList: any[] = [];
    filteredBranchList: any[] = [];
    allBranchList: any[] = [];
    toWhomList: any[];
    billDetailList: any[];
    freeItemList: any[];
    serviceList: any[];
    usingMethodList: any[];
    ratingList: any[];
    drList: any[];
    communicationTypeList: any[];
    summaryStatusList: any[];
    storeUserList: any[] = [];
    hvUserList: any[] = [];
    col_statusList: any;
    page = {
        limit: 10,
        count: 0,
        offset: 0,
        orderBy: 'date',
        orderDir: 'desc'
    };
    isLoadMask: Promise<any>;
    haList: any[] = [];
    hapromoList: any[] = [];
    loadingIndicator: boolean = true;
    //followUpHistoryList = [];
    columns = [];
    emplist1Ctrl: FormControl;
    complCtrl: FormControl;
    emplist2Ctrl: FormControl;
    filteredHa: Observable<any[]>;
    filteredEmp1: Observable<any[]>;
    filteredEmp2: Observable<any[]>;
    filteredTypes: Observable<any[]>;
    filteredhvComplaint: Observable<any[]>;
    filteredsoaComplaint: Observable<any[]>;
    unsoldFeedBackList: any[];
    empList: any[] = [];
    soldFeedBackList: any[];
    followTypeList: any[];
    hvTypeList: any[];
    soaTypeList: any[];
    hvList: any[];
    testingList: any[] = [];
    soaList: any[];
    HVstatusList: any[];
    minDate: any;
    temp_warranty: any = "";
    next_oneyear_fol_disp_date: any;
    next_twoyear_fol_disp_date: any;
    next_twoandhalf_year_fol_disp_date: any;
    next_oneandhalf_year_fol_disp_date: any;
    next_sixmonth_fol_disp_date: any;
    next_onemonth_fol_disp_date: any;
    user_type: any;
    @ViewChild('emp1listAutoComp') emp1listAutoComp;
    @ViewChild('emp2listAutoComp') emp2listAutoComp;
    @Input() set followUpDet(val: any[]) {
        this._followUpDet = val;
        if (this.user_type != 'Super_Admin' && this.user_type != 'Admin') {
            this._followUpDet['mobile'] = this._followUpDet['disp_mobile'];
        }
        this.loadFollowUpDetails();
        // this.pageCallback({ offset: 0 });
        if (this._followUpDet && this._followUpDet['fol_type'] === 'AI Follow Up') {
            this.showAiPickConfirm = true;
        } else {
            this.onClickPick();//INITIAL PICK OPEN
        }
    }
    hasInitialSetup: boolean = true;

    get followUpDet(): any[] {
        return this._followUpDet;
    }
    scrollTimeout: any;
    suppressPaging: boolean = false;
    constructor(
        public store: Store<fromRootStore.State>, public bsModalRef: BsModalRef, public toasterService: ToasterService,
        private followUpService: FollowUpService, public commonService: CommonService) {

        function hasValidUnSold(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Willing" && ledgerID != "Not-Willing"
                && ledgerID != "No-Answer") {
                retVal = { inValidUnsold: true };
            }

            return retVal;
        }
        this.unsoldCtrl = new FormControl('', [
            Validators.required,
            hasValidUnSold.bind(this)
        ]);
        // this.unsoldCtrl = new FormControl();
        this.unsoldFeedBackList = ['Willing', 'Not-Willing', 'No-Answer'];
        this.col_statusList = ['One Month Completed', 'Six Month Completed', 'One Year Completed', '1.6 Year Completed', 'Two Year Completed', '2.6 Year Completed'];
        function hasValidSold(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Satisfied" && ledgerID != "Not-Satisfied"
                && ledgerID != "No-Answer") {
                retVal = { inValidSold: true };
            }

            return retVal;
        }
        this.loadClientTypeList();
        this.soldCtrl = new FormControl('', [
            Validators.required,
            hasValidSold.bind(this)
        ]);
        //this.soldCtrl = new FormControl();
        this.soldFeedBackList = ['Satisfied', 'Not-Satisfied', 'No-Answer'];
        this.followTypeList = ['Call Drop', 'Follow Up', 'Not Ok', 'Done', 'Not Willing Now'];
        //this.hvTypeList = ['HV', 'HV-Recheckup', 'HV-Fitting','HV-ReTrial','HV-ReTrail-Fitting'];
        //  this.soaTypeList = ['SOA', 'SOA-Recheckup', 'SOA-Fitting','SOA-ReTrial','SOA-ReTrail-Fitting'];
        //  this.hvList = ['Sold', 'Unsold','Cancel','Advance','EMI','HV-EMI', 'HV-RecheckUp',
        //   'HV-Retrail-Unsold','HV-Retrail-Sold', 'HV-Retrail-Advance','HV-Retrail-EMI', 
        //   'HV-Delivery', 'HV-Retrail-Delivery'];
        // this.soaList = ['Sold', 'Unsold','Cancel','Advance','EMI','SOA-EMI', 'SOA-RecheckUp',
        //  'SOA-Retrail-Unsold','SOA-Retrail-Sold', 'SOA-Retrail-Advance','SOA-Retrail-EMI', 
        //  'SOA-Delivery', 'SOA-Retrail-Delivery'];

        this.folTypeCtrl = new FormControl();
        this.hvStatusCtrl = new FormControl();
        this.soaStatusCtrl = new FormControl();
        this.hvCtrl = new FormControl();
        this.soaCtrl = new FormControl();
        this.followUpDateCtrl = new FormControl();

        function hasValidUser(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidHAuser: true };
            }

            return retVal;
        }
        this.haUserCtrl = new FormControl('', [
            Validators.required,
            hasValidUser.bind(this)
        ]);
        this.userList = ['Yes', 'No'];

        function hasValidToWhom(input: FormControl) {
            let toWhom = input.value, retVal = null;
            if (toWhom != "SELF" && toWhom != "OTHERS") {
                retVal = { inValidToWhom: true };
            }

            return retVal;
        }
        this.toWhomControl = new FormControl('', [
            Validators.required,
            hasValidToWhom.bind(this)
        ]);
        this.toWhomList = ['SELF', 'OTHERS'];
        //FOR AUTO COMPLETE VALIDATION --- 
        function hasValidDr(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidDr: true };
            }

            return retVal;
        }
        this.drConsCtrl = new FormControl('', [
            Validators.required,
            hasValidDr.bind(this)
        ]);
        this.drList = ['Yes', 'No'];

        // bill Detail
        function hasValidBill(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidBillDetail: true };
            }

            return retVal;
        }
        this.billDetailCtrl = new FormControl('', [
            Validators.required,
            hasValidBill.bind(this)
        ]);
        this.billDetailList = ['Yes', 'No'];



        ///free ITEM
        function hasValidFree(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidFreeItem: true };
            }

            return retVal;
        }
        this.freeItemCtrl = new FormControl('', [
            Validators.required,
            hasValidFree.bind(this)
        ]);
        this.freeItemList = ['Yes', 'No'];

        //this.getBranchList();
        function hasValidBranch(input: FormControl) {
            let branchID = input.value;
            let femp = _.find(this.branchList, { 'branch_id': branchID });
            if (femp)
                return null;
            return { inValidBranch: true };
        }
        this.branchCtrl = new FormControl('', [
            Validators.required,
            hasValidBranch.bind(this)
        ]);

        //NEW BRANCH FOR DUMMY SALES
        function hasValidNewBranch(input: FormControl) {
            let branchID = input.value;
            if (!branchID) return null; // Allow empty values since this is optional
            let femp = _.find(this.allBranchList, { 'branch_id': branchID });
            if (femp)
                return null;
            return { inValidNewBranch: true };
        }
        this.newBranchCtrl = new FormControl('', [
            hasValidNewBranch.bind(this)
        ]);

        //SMS ADDRESS
        function hasValidSmsAddress(input: FormControl) {
            let branchSmsID = input.value;
            let femp = _.find(this.smsBranch, { 'branch_id': branchSmsID });
            if (femp)
                return null;
            return { inValidBranchsms: true };
        }
        this.branchSmsCtrl = new FormControl('', [
            Validators.required,
            hasValidSmsAddress.bind(this)
        ]);
        this.branchSmsCtrl.valueChanges.subscribe

        // SERVICE
        function hasValidService(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidService: true };
            }

            return retVal;
        }
        this.serviceCtrl = new FormControl('', [
            Validators.required,
            hasValidService.bind(this)
        ]);
        this.serviceList = ['Yes', 'No'];

        // Using Method
        function hasValidUsingMethod(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidUsingMethod: true };
            }

            return retVal;
        }
        this.usingMethodCtrl = new FormControl('', [
            Validators.required,
            hasValidUsingMethod.bind(this)
        ]);
        this.usingMethodList = ['Yes', 'No'];

        // Rating
        function hasValidRating(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Very Good" && ledgerID != "Good"
                && ledgerID != "Normal" && ledgerID != "Bad") {
                retVal = { inValidRating: true };
            }

            return retVal;
        }
        this.ratingCtrl = new FormControl('', [
            Validators.required,
            hasValidRating.bind(this)
        ]);
        this.ratingList = ['Very Good', 'Good', 'Normal', 'Bad'];

        // Communication Type
        this.communicationTypeList = ['Phone', 'Whatsapp', 'Email', 'Call', 'Home Visit'];
        this.communicationTypeCtrl = new FormControl();

        // Summary Status
        this.summaryStatusList = ['HOT', 'WARM', 'COLD'];
        this.summaryStatusCtrl = new FormControl();

        // this.HVTypeCtrl = new FormControl();
        //this.filteredItems = this.skuCtrl.valueChanges
        //    .startWith(null)
        //    .map(name => name ? this.filterItems(name) : this.itemList.slice());

        //FOR AUTO COMPLETE VALIDATION --- FOLLOW UP STATUS
        function hasValidStatus(input: FormControl) {
            let statusID = input.value, retVal = null;
            if (statusID == "") {
                retVal = { inValidStatus: true };
            }
            if (statusID && typeof statusID === 'string') {
                retVal = { inValidStatus: true };
            }
            return retVal;
        }
        this.statusCtrl = new FormControl('', [
            Validators.required,
            hasValidStatus.bind(this)
        ]);

        //FOR AUTO COMPLETE VALIDATION --- ASSIGN TO LIST
        function hasValidAssignto(input: FormControl) {
            let statusID = input.value, retVal = null;
            if (statusID == "") {
                retVal = { inValidAssignTo: true };
            }
            if (statusID && typeof statusID === 'string') {
                retVal = { inValidAssignTo: true };
            }
            return retVal;
        }
        this.assignToCtrl = new FormControl('', [
            Validators.required,
            hasValidAssignto.bind(this)
        ]);
        this.assignToCtrl.valueChanges
            .startWith(null)
            .subscribe((val) => {
                if (val && typeof val === 'string') {
                    const search = _.escapeRegExp(val);
                    this.filteredAssignToList = (this.assignToList || []).filter(u =>
                        new RegExp(search, 'gi').test(u.fullname)
                    );
                } else {
                    this.filteredAssignToList = (this.assignToList || []).slice();
                }
            });

        // NEW BRANCH SEARCH FUNCTIONALITY
        this.newBranchCtrl.valueChanges
            .startWith(null)
            .subscribe((val) => {
                if (val && typeof val === 'string') {
                    const search = _.escapeRegExp(val);
                    this.filteredBranchList = (this.allBranchList || []).filter(branch =>
                        new RegExp(search, 'gi').test(branch.branch_name)
                    );
                } else {
                    this.filteredBranchList = (this.allBranchList || []).slice();
                }
            });

        // Employee Name autocomplete
        function hasValidEmployee(input: FormControl) {
            let empID = input.value, retVal = null;
            if (empID && !isNaN(empID) && empID > 0) {
                return null; // Valid employee ID
            } else if (empID && (isNaN(empID) || empID <= 0)) {
                retVal = { inValidEmployee: true };
            }
            return retVal;
        }

        function hasRequiredEmployee(input: FormControl) {
            let empID = input.value;
            // Only validate for Unsold followup team
            if (this && (this['followUpTeam'] == 'Unsold' || this['followUpTeam'] == 'Unsold OCT')) {
                // Check if value is empty, null, undefined, 0, or "0"
                if (!empID || empID === 0 || empID === '0' || empID === '') {
                    return { required: true };
                }
                // If we have a numeric value greater than 0, it's valid
                if (typeof empID === 'number' && empID > 0) {
                    return null;
                }
                // If we have a string that represents a number greater than 0, it's valid
                if (typeof empID === 'string' && !isNaN(Number(empID)) && Number(empID) > 0) {
                    return null;
                }
                // If none of the above, consider it invalid
                return { required: true };
            }
            return null;
        }

        this.empNameCtrl = new FormControl('', [hasValidEmployee.bind(this)]);
        let that = this;
        this.filteredEmpName = this.searchTermsEmp
            .debounceTime(300)
            .distinctUntilChanged()
            .switchMap(term => term
                ? this.commonService.getEmployeeList(term, 'challan')
                : Observable.of<EmployeeModel[]>([]))
            .catch(error => {
                console.log(error);
                return Observable.of<EmployeeModel[]>([]);
            });
        this.filteredEmpName.subscribe(($e) => {
            that.empNameList = $e;
        });

        // Load complete employee list for display function when it's Unsold followup
        if (this['followUpTeam'] == 'Unsold' || this['followUpTeam'] == 'Unsold OCT') {
            this.commonService.getUserList({}).then((res: any) => {
                if (res && res.data) {
                    // Ensure empNameList has the complete list for displayEmpName function
                    that.empNameList = [...(that.empNameList || []), ...res.data];
                    // Remove duplicates based on empid/userid
                    that.empNameList = that.empNameList.filter((emp, index, self) =>
                        index === self.findIndex((e) => (e.empid || e.userid) === (emp.empid || emp.userid))
                    );
                }
            });
        }

        //FOR AUTO COMPLETE VALIDATION --- TYPE
        function hasValidType(input: FormControl) {
            let type = input.value, retVal = null;
            if (type == "") {
                retVal = { inValidType: true };
            }
            let typeVal = this.followTypeList.find(function (element) {
                if (element == input.value) return true;
            })
            if (!typeVal) {
                retVal = { inValidType: true };
            }
            return retVal;
        }
        this.folTypeCtrl = new FormControl('', [
            Validators.required,
            hasValidType.bind(this)
        ]);



        function hasEmp1(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidEMP1: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidEMP1: true };
            }
            return retVal;
        }
        this.emplist1Ctrl = new FormControl('', [
            Validators.required,
            hasEmp1.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        this.filteredEmp1 = this.emplist1Ctrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHa(name) : this.haList.slice());


        function hasEmp2(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidEMP2: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidEMP2: true };
            }
            return retVal;
        }
        this.emplist2Ctrl = new FormControl('', [
            Validators.required,
            hasEmp2.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        this.filteredEmp2 = this.emplist2Ctrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHa(name) : this.haList.slice());

        function hasValidHaModel(input: FormControl) {
            let ModelID = input.value, retVal = null;

            if (ModelID == "") {
                retVal = { inValidHaModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidHaModel: true };
            }
            return retVal;
        }
        this.halistCtrl = new FormControl('', [
            Validators.required,
            hasValidHaModel.bind(this)
        ]);

        this.filteredHa = this.halistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHaPromo(name) : this.hapromoList.slice());

        function hashvComplaint(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidhvComplaint: true };
            }
            /* if (ModelID && typeof ModelID === 'string') {
                 retVal = { inValidComplaint: true };
             }*/
            return retVal;
        }
        this.hvcomplaintCtrl = new FormControl('', [
            Validators.required,
            hashvComplaint.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        this.filteredhvComplaint = this.hvcomplaintCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterhvComplaint(name) : this.hvcomplaintList.slice());

        function hassoaComplaint(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidsoaComplaint: true };
            }
            /* if (ModelID && typeof ModelID === 'string') {
                 retVal = { inValidComplaint: true };
             }*/
            return retVal;
        }
        this.soacomplaintCtrl = new FormControl('', [
            Validators.required,
            hassoaComplaint.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        this.filteredsoaComplaint = this.soacomplaintCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filtersoaComplaint(name) : this.soacomplaintList.slice());

        function hasValidTestType(input: FormControl) {
            let testTypeID = input.value, retVal = null;
            if (testTypeID == "") {
                retVal = { inValidTestType: true };
            }
            if (testTypeID && typeof testTypeID === 'string') {
                retVal = { inValidTestType: true };
            }
            return retVal;
        }
        this.testingtypeCtrl = new FormControl('', [
            Validators.required,
            hasValidTestType.bind(this)
        ]);

        //this.testingtypeCtrl = new FormControl();
        this.filteredTypes = this.testingtypeCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterTypes(name) : this.testingList.slice());


        function hasValidPothv(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidPothv: true };
            }

            return retVal;
        }
        this.hvpotCtrl = new FormControl('', [
            Validators.required,
            hasValidPothv.bind(this)
        ]);
        this.hvpotCusOptList = ['Yes', 'No'];

        function hasValidPotsoa(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidPotsoa: true };
            }

            return retVal;
        }
        this.soapotCtrl = new FormControl('', [
            Validators.required,
            hasValidPotsoa.bind(this)
        ]);
        this.soapotCusOptList = ['Yes', 'No'];



    }

    ngOnInit() {

        let that = this;
        this.loadChallanHaList();
        this.loadChallanHaPromoList();
        this.loadhvComplaint();
        this.loadsoaComplaint();
        this.getStoreUser();
        this.getHVUser();
        this.clientFollowDet['important'] = false;
        this.clientFollowDet['willing'] = false;
        this.clientFollowDet['cancelled'] = false;

        if (that['followUpTeam'] == 'AfterSales') {
            this.unsoldFeedBackList = [];
        }

        this.singleClientDetails.followUpClientEvent.subscribe(($e) => {
            if (that['followUpTeam'] == 'Sold' || that['followUpTeam'] == 'HV' || that['followUpTeam'] == 'SOA') {
                let fromCall = $e['fromCall'];
                if (fromCall == 'billTab') {

                    this.next_twoyear_fol_disp_date = $e['next_twoyear_fol_disp_date'];
                    this.next_onemonth_fol_disp_date = $e['next_onemonth_fol_disp_date'];
                    this.next_sixmonth_fol_disp_date = $e['next_sixmonth_fol_disp_date'];
                    this.next_oneandhalf_year_fol_disp_date = $e['next_oneandhalf_year_fol_disp_date'];
                    this.next_twoandhalf_year_fol_disp_date = $e['next_twoandhalf_year_fol_disp_date'];
                    this.next_oneyear_fol_disp_date = $e['next_oneyear_fol_disp_date'];
                    that.clientFollowDet['next_oneyear_fol_disp_date'] = $e['next_oneyear_fol_disp_date'];
                    that.clientFollowDet['next_twoyear_fol_disp_date'] = $e['next_twoyear_fol_disp_date'];
                    that.clientFollowDet['next_onemonth_fol_disp_date'] = $e['next_onemonth_fol_disp_date'];
                    that.clientFollowDet['next_sixmonth_fol_disp_date'] = $e['next_sixmonth_fol_disp_date'];
                    that.clientFollowDet['next_oneandhalf_year_fol_disp_date'] = $e['next_oneandhalf_year_fol_disp_date'];
                    that.clientFollowDet['next_twoandhalf_year_fol_disp_date'] = $e['next_twoandhalf_year_fol_disp_date'];
                    that.clientFollowDet['warranty'] = $e['warranty'];
                    that.clientFollowDet['fol_col_status'] = $e['fol_col_status'];
                    that.temp_warranty = $e['warranty'];


                }
            }
        });

        //this.loadFollowUpStatus();
        /*this.store.select(fromCommonStore.getAllFollowUpStatus).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            console.log(that);
            debugger;
            this.followUpStatusList = _.filter(res.data, function(obj) { return obj['is_followup'] == 'Yes' });
        });*/
        //this.skuAutoComp.optionSelected.subscribe(this.onSelectedSku.bind(this));
        //this.pageCallback({ offset: 0 });

        /*   this.columns = [
               { name: 'Date', prop: 'fol_date', width: 120, minWidth: 120, maxWidth: 120, toggle: true },
               { name: 'Description', prop: 'description', width: 500, minWidth: 500, maxWidth: 500 },
               { name: 'Status', prop: 'status_name', sortable: false, cellClass: 'cell-left', width: 120, minWidth: 120, maxWidth: 120 }
           ];*/

        this.minDate = new Date(new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate());

        this.clientFollowDet['date'] = new Date();
        this.clientFollowDet['hv_date'] = new Date();
        this.clientFollowDet['soa_date'] = new Date();

        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                //this.store.dispatch(new commonActions.LoadAllBrand());
                //this.brandList$ = res;
                return;
            }
            this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
                this.user_type = auth['usertype'];
                if (auth['islogin']) {
                    let branchs = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' });
                    this.branchList = _.filter(branchs, function (obj) { return obj['branch_id'] != auth['branch_id'] });
                    this.allBranchList = branchs.slice();
                    this.filteredBranchList = branchs.slice();
                    this.smsBranch = _.filter(res.data, function (obj) { return obj['is_followup_branch'] == 'yes' });
                    this.branch_chk_name = _.filter(res.data, function (obj) { return obj['chk_name'] });
                }
                this.user_branch_name = auth['fullname'];
                this.userid = auth['userid'];
            });

        });

    }
    loadhvComplaint() {
        let that = this;
        this.commonService
            .getComplaintList()
            .then(function (res: any) {
                that.hvcomplaintList = res;
                that.hvcomplaintCtrl.setValue(that.clientFollowDet['comp_name']);

            });
    }
    filterhvComplaint(comp_name: string) {
        comp_name = _.escapeRegExp(comp_name);
        return this.hvcomplaintList.filter(item => (new RegExp(comp_name, 'gi').test(item.comp_name)
            || new RegExp(comp_name, 'gi').test(item.comp_name)));
    }

    displayhvComplaint(comp_name: string) {

        if (comp_name && this.hvcomplaintList.length > 0) {
            let flist = _.find(this.hvcomplaintList, { 'comp_name': comp_name });
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            //  this.getModelSerialNo(it_id);

            return flist['comp_name'];
        }
        return '';
    }

    loadsoaComplaint() {
        let that = this;
        this.commonService
            .getComplaintList()
            .then(function (res: any) {
                that.soacomplaintList = res;
                that.soacomplaintCtrl.setValue(that.clientFollowDet['comp_name']);

            });
    }
    filtersoaComplaint(comp_name: string) {
        comp_name = _.escapeRegExp(comp_name);
        return this.soacomplaintList.filter(item => (new RegExp(comp_name, 'gi').test(item.comp_name)
            || new RegExp(comp_name, 'gi').test(item.comp_name)));
    }

    displaysoaComplaint(comp_name: string) {

        if (comp_name && this.soacomplaintList.length > 0) {
            let flist = _.find(this.soacomplaintList, { 'comp_name': comp_name });
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            //  this.getModelSerialNo(it_id);

            return flist['comp_name'];
        }
        return '';
    }

    loadChallanHaPromoList() {
        let that = this,
            data = {
                stock_type: 'HA MODEL'
            };
        this.commonService
            .getHaModelTrailStock(data)
            .then(function (res: any) {
                that.hapromoList = res['haStockModel'];
                // that.actSerialNoList = res['haModelStockSerial'];
                that.halistCtrl.setValue(that.clientFollowDet['model_id']);
            });
    }

    filterHaPromo(name: string) {
        name = _.escapeRegExp(name);
        return this.hapromoList.filter(ha => (new RegExp(name, 'gi').test(ha.model_id) || new RegExp(name, 'gi').test(ha.name)));
    }

    loadChallanHaList() {
        let that = this,
            data = {
                name: '',
                type: 'challan'
            };
        this.commonService
            .getEmployeeName(data)
            .then(function (res: any) {
                that.haList = res['data'];
                // that.actSerialNoList = res['haModelStockSerial'];
                that.emplist1Ctrl.setValue(that.clientFollowDet['empid']);
                //that.emplist2Ctrl.setValue(that.clientFollowDet['empid']);
            });
    }

    filterHa(empname: string) {
        empname = _.escapeRegExp(empname);
        return this.haList.filter(ha => (new RegExp(empname, 'gi').test(ha.empid)
            || new RegExp(empname, 'gi').test(ha.empname)));
    }

    searchEmployee(query: string) {
        this.searchTermsEmp.next(query);
    }

    displayEmpName(empID: number) {
        if (empID && this.empNameList && this.empNameList.length > 0) {
            // First try to find by empid, then by userid
            let femp = _.find(this.empNameList, { 'empid': empID }) || _.find(this.empNameList, { 'userid': empID });
            if (femp) {
                return femp['empname'] || femp['fullname'];
            }
        }
        return '';
    }

    displayHa(item_id: number) {

        if (item_id && this.haList.length > 0) {
            let fhalist = _.find(this.haList, { 'empid': item_id });
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            //  this.getModelSerialNo(item_id);
            return fhalist['empname'];
        }
        return '';
    }
    onSelectedStatus(status) {
        if (!_.isEmpty(status)) {
            this.testingtypeCtrl.disable();
            if (status == 'Testing') {
                this.testingtypeCtrl.enable();
                if (_.isEmpty(this.testingList)) {
                    this.loadClientTypeList();
                }
            }
        }
    }
    loadClientTypeList() {
        let that = this;
        this.commonService
            .getTestingtypeList()
            .then(function (res: any) {
                that.testingList = res;
                that.testingtypeCtrl.setValue(that.clientFollowDet['testing_id']);
            });
    }
    displayType(type_id: number) {
        if (type_id && this.testingList.length > 0) {
            let ftype = _.find(this.testingList, { 'id': type_id });
            return ftype['name'];
        }
        return '';
    }

    filterTypes(name: string) {
        name = _.escapeRegExp(name);
        return this.testingList.filter(type => (new RegExp(name, 'gi').test(type.name)));
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }
    /*  pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
          if (!this.suppressPaging) {
              this.page.offset = pageInfo.offset;
           //   this.getClientHistory();
          }
      }*/

    loadFollowUpDetails() {
        if (this._followUpDet != undefined) {
            let that = this;
            this.store.select(fromCommonStore.getAllFollowUpStatus).subscribe((res: any) => {
                if (_.isEmpty(res.data)) {
                    return;
                }
                let followup = that['followUpTeam'];
                let statusDetails = _.filter(res.data, function (obj) { return obj['fol_id'] == that._followUpDet['status'] });
                this.followUpStatusList = _.filter(res.data, function (obj) {
                    if (followup === 'NotWillingNow') {
                        return obj['is_followup'] == 'Yes' && obj['nwn_' + statusDetails[0]['team_id']] == 'Yes';
                    } else if (followup === 'HV' && that._followUpDet['status'] != 5 && that.userid == 105) {
                        return obj['is_followup'] == 'Yes' && obj[followup] == 'Yes' && obj['hv_1'] == 'Yes';
                    } else if (followup === 'HV' && that._followUpDet['status'] != 5 && that.userid == 108) {
                        return obj['is_followup'] == 'Yes' && obj[followup] == 'Yes' && obj['hv_2'] == 'Yes';
                    } else if (followup == 'Trial Not Willing') {
                        return obj['trial_not_willing'] === 'Yes';
                    } else if (followup == 'Bilateral Willing Client') {
                        return obj['bilateral_willing_client'] === 'Yes';
                    } else if (followup == 'Store Followup' && that.userid == 174) {
                        return (obj[followup] == 'Yes' || obj['fol_id'] == 1);
                    } else if (followup == 'Store Followup') {
                        return obj[followup] == 'Yes';
                    } else if (followup == 'Store Service Followup') {
                        return obj['store_service_followup'] == 'Yes';
                    } else {
                        return obj['is_followup'] == 'Yes' && obj[followup] == 'Yes';
                    }
                });
                if (followup === 'CAMP PROMO') {
                    this.statusCtrl.disable();
                }
                if (followup === 'NotWillingNow' && that._followUpDet['status'] != 5) { // Not UNSOLD 
                    if (!this.followUpStatusList.some(status => status.fol_id === statusDetails[0]['fol_id'])) {
                        this.followUpStatusList.push(statusDetails[0]);
                    }
                }
                this.hvTypeList = _.filter(res.data, function (obj) { return obj['hv_status'] == 'Yes' });
                this.soaTypeList = _.filter(res.data, function (obj) { return obj['soa_status'] == 'Yes' });
                this.hvList = _.filter(res.data, function (obj) { return obj['hv_out_status'] == 'Yes' });
                this.soaList = _.filter(res.data, function (obj) { return obj['soa_out_status'] == 'Yes' });
            });
            this._followUpDet['followUpTeam'] = this['followUpTeam'];
            this.singleClientDetails.loadClient(this._followUpDet);//TO LOAD CLIENT OBJECT
            // TO REMOVE NOT-WILLING-NOW OPYION FROM SELECT BOX FOR NOT WILLING NOW FOLLOWUP
            if (this._followUpDet['fol_type'] == "Not Willing Now") {
                this.followTypeList.pop();
            }
            // let that = this,
            //     clientID = this._followUpDet['client_id'],
            //     data = {
            //         client_id: clientID
            //     };
            //
            // this.followUpService
            //     .getFollowUpDetails(data)
            //     .then(function(res: any) {
            //         //that.isLoading = false;
            //         if (res.success) {
            //             that.clientPerDet = res.clientPerDet;
            //             //that.bsModalRef.hide();
            //             //that.skuUpdateEvent.emit();
            //             if (that._followUpDet['mode'] == 'edit') {
            //                 that.onClickPick();
            //             }
            //         } else {
            //             swal('ERROR', res.message, 'error');
            //         }
            //
            //     })
            //     .catch(function(error: any) {
            //         //that.isLoading = false;
            //         let res = JSON.parse(error._body);
            //         swal('ERROR', res.message, 'error');
            //         //console.log(error);
            //     });
        }
    }
    // setFollowUpDetails(clientDet: object): void {
    //     //this.showFollowUpForm = true;
    //     this.onClickPick();
    //     //this.clientFollowDet = clientDet;
    // }
    loadFollowUpStatus(): void {
        let that = this;

        // that.commonService
        //     .getFollowUpStatusList({})
        //     .then(function(res: any) {
        //         that.followUpStatusList = res.data;
        //         //debugger;
        //         //that.clientList = res.data;
        //         //that.gridClientList = res.data;
        //         //that.page.count = res.totCnt;
        //         //that.clientCtrl.setValue(that.clientInData['client_id']);
        //         // if (that.mode == "Edit") {
        //         //     that.skuCtrl.disable();
        //         //     $('#sku_gms').focus();
        //         // }
        //     });
    }
    povStatusChanged() {
        let that = this;
        if (!that.hasInitialSetup) {
            that.statusCtrl.setValue(that.clientFollowDet['hv_type']);
        }
    }
    onChangeStatus(fol_id: any) {
        let that = this;
        let followup = that['followUpTeam'];
        if (this.clientFollowDet['hv_type'] !== fol_id && followup === 'HV') {
            swal({
                title: "CONFIRMATION",
                type: "warning",
                text: "Do you want to change the status?",
                confirmButtonText: 'Yes',
                showCancelButton: true,
            }).then(res => {

            }, () => {
                this.clientFollowDet['status'] = this.clientFollowDet['hv_type'];
            });
        }
    }
    // CHECK FOLLOWUP ASIGNEE
    checkFollowupAssignee(status) {
        const folAssigneeObj = _.find(this.followUpStatusList, function (obj) { return obj['fol_id'] == status });
        return folAssigneeObj ? true : false;
    }
    getStoreUser() {
        let that = this;
        that.commonService
            .getStoreUserList()
            .then(function (res: any) {
                that.storeUserList = res.data;
            });
    }
    getHVUser() {
        let that = this;
        that.commonService
            .getHVTechnicianList()
            .then(function (res: any) {
                that.hvUserList = res.data;
            });
    }
    displayFn(folID: any) {
        let that = this;
        that.staname = true;
        // if (folID && folID != "") {

        //     that.clientFollowDet['assign_empid'] = "";
        //     let data = {
        //         fol_id: folID
        //     };

        //     that.commonService
        //         .getUserList(data)
        //         .then(function (res: any) {
        //             that.assignToList = res.data;
        //             if (that._followUpDet['mode'] == 'edit') {
        //                 that.assignToCtrl.setValue(that.clientFollowDet['act_assign_empid']);
        //             }
        //         });
        // }

        if (that['followUpTeam'] == 'Store Followup' || that['followUpTeam'] == 'Store Service Followup') {
            that.clientFollowDet['assign_empid'] = "";
            if (folID && this.checkFollowupAssignee(folID)) {
                let data = {
                    fol_id: folID
                };

                that.commonService
                    .getUserList(data)
                    .then(function (res: any) {
                        // console.log("assignToList",that.user_branch_name);
                        that.storeUserList = _.filter(that.storeUserList, function (obj) { return obj['fullname'] == that.user_branch_name });
                        // console.log("storeUserList",that.storeUserList);
                        that.assignToList = res.data;
                        // Merge the arrays using the spread operator
                        that.assignToList = [...that.storeUserList, ...that.assignToList];
                        // Remove duplicates while preserving order
                        that.assignToList = that.assignToList.filter(
                            (value, index, self) =>
                                index === self.findIndex((v) => v.userid === value.userid)
                        );
                        that.filteredAssignToList = that.assignToList.slice();
                    });
            }
        } else {
            if (folID && folID != "") {

                if (that['followUpTeam'] !== 'CAMP PROMO') {
                    that.clientFollowDet['assign_empid'] = "";
                }
                let data = {
                    fol_id: folID
                };

                that.commonService
                    .getUserList(data)
                    .then(function (res: any) {
                        that.assignToList = res.data;

                        // Filter out UNSOLD and HV users for SOA team
                        if (that['followUpTeam'] == 'SOA') {
                            that.assignToList = _.filter(that.assignToList, function (obj) {
                                return obj['fullname'] != 'UNSOLD' && obj['fullname'] != 'HV  2';
                            });
                        }

                        if (that['followUpTeam'] == 'Unsold' || that['followUpTeam'] == 'Unsold OCT' || that['followUpTeam'] == 'Trial Not Willing' || that['followUpTeam'] == 'Bilateral Willing Client') {
                            // Merge the arrays using the spread operator
                            that.assignToList = [...that.storeUserList, ...that.assignToList];
                            // Remove duplicates while preserving order
                            that.assignToList = that.assignToList.filter(
                                (value, index, self) =>
                                    index === self.findIndex((v) => v.userid === value.userid)
                            );
                        }
                        if (that['followUpTeam'] == 'HV' || that['followUpTeam'] == 'Unsold') {
                            // Merge HV Technicians into Assign To list
                            that.assignToList = [...that.hvUserList, ...that.assignToList];
                            // Remove duplicates while preserving order
                            that.assignToList = that.assignToList.filter(
                                (value, index, self) =>
                                    index === self.findIndex((v) => v.userid === value.userid)
                            );
                        }
                        that.filteredAssignToList = that.assignToList.slice();
                        if (that._followUpDet['mode'] == 'edit') {
                            that.assignToCtrl.setValue(that.clientFollowDet['act_assign_empid']);
                            // Set employee name control for Unsold followup
                            if (that['followUpTeam'] == 'Unsold' || that['followUpTeam'] == 'Unsold OCT') {
                                that.empNameCtrl.setValue(that.clientFollowDet['emp_assign']);
                                that.empNameCtrl.markAsTouched();
                                that.empNameCtrl.updateValueAndValidity();
                            }
                        }
                        if (that['followUpTeam'] === 'CAMP PROMO') {
                            const campAssignId = that._followUpDet['assign_empid'];
                            that.clientFollowDet['assign_empid'] = campAssignId;
                            that.assignToCtrl.setValue(campAssignId);
                        }
                    });
            }
        }

        if (this.followUpStatusList != undefined) {
            if (folID && this.followUpStatusList.length > 0) {
                let fitem = _.find(this.followUpStatusList, { 'fol_id': folID });
                return fitem['name'];
            }
        }
        return '';
    }

    displayFnHV(folID: any) {
        if (this.hvTypeList != undefined) {
            if (folID && this.hvTypeList.length > 0) {
                let fitem = _.find(this.hvTypeList, { 'fol_id': folID });
                return fitem['name'];
            }
        }
        return '';
    }
    assignFn(empid: any) {
        if (this.assignToList != undefined) {
            if (empid && this.assignToList.length > 0) {
                let fitem = _.find(this.assignToList, { 'userid': empid });
                return fitem['fullname'];
            }
        }
        return '';
    }

    displayFnSOA(folID: any) {
        if (this.soaTypeList != undefined) {
            if (folID && this.soaTypeList.length > 0) {
                let fitem = _.find(this.soaTypeList, { 'fol_id': folID });
                return fitem['name'];
            }
        }
        return '';
    }
    displayFnHVOUT(folID: any) {
        if (this.hvList != undefined) {
            if (folID && this.hvList.length > 0) {
                let fitem = _.find(this.hvList, { 'fol_id': folID });
                return fitem['name'];
            }
        }
        return '';
    }
    displayFnSOAOUT(folID: any) {
        if (this.soaList != undefined) {
            if (folID && this.soaList.length > 0) {
                let fitem = _.find(this.soaList, { 'fol_id': folID });
                return fitem['name'];
            }
        }
        return '';
    }


    displayBranch(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                if (typeof branchID == 'string') {
                    branchID = parseInt(branchID);
                }
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                //this.branchList['company_name'] = fitem.branchList; //ANOTHER FIELD
                return fitem['branch_name'];
            }
        }
        return '';

    }

    displayNewBranch(branchID: any) {
        if (this.allBranchList != undefined) {
            if (branchID && this.allBranchList.length > 0) {
                if (typeof branchID == 'string') {
                    branchID = parseInt(branchID);
                }
                let fitem = _.find(this.allBranchList, { 'branch_id': branchID });
                return fitem ? fitem['branch_name'] : '';
            }
        }
        return '';
    }
    displayBranchaddr(branchID: any) {
        if (this.folTypeCtrl.value == 'Call Drop') {
            swal('ERROR', "You are selected CALL DROP\nSo you can't select SMS ADDRESS", 'error');
            return '';
        }
        if (this.smsBranch != undefined) {
            if (branchID && this.smsBranch.length > 0) {
                if (typeof branchID == 'string') {
                    branchID = parseInt(branchID);
                }
                let fitem = _.find(this.smsBranch, { 'branch_id': branchID });
                //this.branchList['company_name'] = fitem.branchList; //ANOTHER FIELD
                return fitem['branch_name'];
            }
        }
        return '';

    }
    /*getClientHistory(): void {
        let that = this,
            clientID = this._followUpDet['client_id'],
            params = {
                start: `${this.page.offset}`,
                limit: `${this.page.limit}`,
                orderColumn: `${this.page.orderBy}`,
                orderDir: `${this.page.orderDir}`,
                from_page: 'followUp',
                client_id: clientID
            };
        this.isLoadMask = this.commonService
            .getClientHistory(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.followUpHistoryList = res.data;
            });
    }*/
    showAiPickConfirm: boolean = false;

    onPickButtonClick(): void {
        if (this._followUpDet && this._followUpDet['fol_type'] === 'AI Follow Up') {
            this.showAiPickConfirm = true;
        } else {
            this.onClickPick();
        }
    }

    onConfirmAiPick(confirmed: boolean): void {
        this.showAiPickConfirm = false;
        if (confirmed) {
            this.onClickPick();
        } else {
            this.bsModalRef.hide();
        }
    }

    onClickPick(): void {
        let that = this,
            clientID = this._followUpDet['client_id'],
            data = {
                client_id: clientID,
                attender_status: 'pick'
            };
        that.isLoading = true;
        this.followUpService
            .changeAttenderStatus(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {

                    that.showFollowUpForm = true;
                    that.clientFollowDet['one_month_sold_date'] = res.one_month_sold_date;
                    if (res.pick_failed) {
                        that.toasterService.pop({ type: 'error', title: 'ERROR', body: res.pick_message });
                    }

                    if (that._followUpDet['mode'] == 'edit') {
                        //let fol_date = new Date(that._followUpDet['date'].replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
                        //that.clientFollowDet = that._followUpDet;
                        //that.followUpDateCtrl.setValue(fol_date);
                        that.clientFollowDet = that._followUpDet;
                        that.clientFollowDet['prev_status'] = that._followUpDet['status'];
                        //that.assignToCtrl.setValue(that.clientFollowDet['assign_empid']);
                        that.clientFollowDet['hv_type'] = that._followUpDet['hv_type'];
                        that.clientFollowDet['next_oneyear_fol_disp_date'] = that.next_oneyear_fol_disp_date;
                        that.clientFollowDet['next_twoyear_fol_disp_date'] = that.next_twoyear_fol_disp_date;
                        that.clientFollowDet['next_twoandhalf_year_fol_disp_date'] = that.next_twoandhalf_year_fol_disp_date;
                        that.clientFollowDet['next_oneandhalf_year_fol_disp_date'] = that.next_oneandhalf_year_fol_disp_date;
                        that.clientFollowDet['next_sixmonth_fol_disp_date'] = that.next_sixmonth_fol_disp_date;
                        that.clientFollowDet['next_onemonth_fol_disp_date'] = that.next_onemonth_fol_disp_date;
                        that.clientFollowDet['next_onemonth_fol_disp_date'] = that.next_onemonth_fol_disp_date;

                        that.clientFollowDet['important'] = eval(that._followUpDet['important']);
                        that.clientFollowDet['willing'] = eval(that._followUpDet['willing']);
                        that.clientFollowDet['follow_up_willing'] = that._followUpDet['follow_up_willing'] || '';
                        that.clientFollowDet['cancelled'] = eval(that._followUpDet['cancelled']);
                        that.clientFollowDet['col_status'] = that._followUpDet['col_status'];
                        that.clientFollowDet['act_assign_empid'] = that._followUpDet['assign_empid'];
                        that.clientFollowDet['warranty'] = that.temp_warranty;
                        that.clientFollowDet['fol_col_status'] = that._followUpDet['col_status'];
                        that.clientFollowDet['one_month_sold_date'] = res.one_month_sold_date;
                        if (that.clientFollowDet['fol_type'] == 'Close') {
                            that.clientFollowDet['fol_type'] = 'Not Ok'
                        } else {
                            that.clientFollowDet['fol_type'] = that._followUpDet['fol_type'];
                        }
                        if (typeof that.clientFollowDet['model_id'] == "number") {
                            that.clientFollowDet['model_id'] = [that.clientFollowDet['model_id']];
                        } else if (!_.isEmpty(that.clientFollowDet['model_id'])) {
                            //let modelIds = this._params['model_id'];
                            //if(typeof this._params['model_id'] == "string"){
                            let modelIds = that.clientFollowDet['model_id'].split(',').map(function (item) {
                                return parseInt(item);
                            });
                            //}               

                            that.clientFollowDet['model_id'] = modelIds;
                        }

                        that.clientFollowDet['date'] = new Date(that._followUpDet['act_date'].
                            replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
                        that.clientFollowDet['hv_date'] = new Date(that.clientFollowDet['hv_date']);
                        that.clientFollowDet['soa_date'] = new Date(that.clientFollowDet['soa_date']);
                        that.clientFollowDet['status'] = that._followUpDet['status'];
                        //that.clientFollowDet['assign_empid'] = that._followUpDet['assign_empid'];
                        if (that['followUpTeam'] === 'CAMP PROMO') {
                            that.staname = true;
                            that.commonService.getCampPromoUsers().then(function (res: any) {
                                that.assignToList = res.data;
                                const campAssignId = that._followUpDet['assign_empid'];
                                that.clientFollowDet['assign_empid'] = campAssignId;
                                that.assignToCtrl.setValue(campAssignId);
                            });
                        }

                    } else if (that._followUpDet['mode'] == 'change') {
                        that.clientFollowDet['to_whom'] = that._followUpDet['to_whom'];
                        that.clientFollowDet['ha_user'] = that._followUpDet['ha_user'];
                        that.clientFollowDet['dr_consulted'] = that._followUpDet['dr_consulted'];
                        that.clientFollowDet['unsold_feedback'] = that._followUpDet['unsold_feedback'];
                        that.clientFollowDet['sold_feedback'] = that._followUpDet['sold_feedback'];
                        that.clientFollowDet['billing_detail'] = that._followUpDet['billing_detail'];
                        that.clientFollowDet['free_item'] = that._followUpDet['free_item'];
                        that.clientFollowDet['service'] = that._followUpDet['service'];
                        that.clientFollowDet['using_method'] = that._followUpDet['using_method'];
                        that.clientFollowDet['rating'] = that._followUpDet['rating'];
                        that.clientFollowDet['relation'] = that._followUpDet['relation'];
                        that.clientFollowDet['attender_profession'] = that._followUpDet['attender_profession'];
                        that.clientFollowDet['relation_age'] = that._followUpDet['relation_age'];
                        that.clientFollowDet['name'] = that._followUpDet['name'];;
                        that.clientFollowDet['hv_type'] = that._followUpDet['hv_type'];
                        that.clientFollowDet['soa_type'] = that._followUpDet['soa_type'];
                        that.clientFollowDet['model_name'] = that._followUpDet['model_name'];
                        that.clientFollowDet['complaint'] = that._followUpDet['complaint'];
                        that.clientFollowDet['potential_customer'] = that._followUpDet['potential_customer'];
                        if (that['followUpTeam'] === 'CAMP PROMO') {
                            const campStatus = that.followUpStatusList.find((s: any) => s.name === 'CAMP PROMO FOLLOW UP');
                            if (campStatus) {
                                that.clientFollowDet['status'] = campStatus.fol_id;
                                that.staname = true;
                                that.commonService.getCampPromoUsers().then(function (res: any) {
                                    that.assignToList = res.data;
                                    const campAssignId = that._followUpDet['assign_empid'];
                                    that.clientFollowDet['assign_empid'] = campAssignId;
                                    that.assignToCtrl.setValue(campAssignId);
                                });
                            }
                        }
                    }
                    // Pre-fill Next Followup Date with the scheduled date for future calendar entries
                    if (that._followUpDet['mode'] !== 'edit' && that._followUpDet['act_date'] && that._followUpDet['act_date'] > new Date().toISOString().slice(0, 10)) {
                        const d = that._followUpDet['act_date'].split('-');
                        that.clientFollowDet['date'] = new Date(parseInt(d[0]), parseInt(d[1]) - 1, parseInt(d[2]));
                    }
                    if (that._followUpDet['status'] == 10)
                        that.clientFollowDet['entry_date'] = that._followUpDet['date'];
                    //that.bsModalRef.hide();
                    //that.skuUpdateEvent.emit();
                } else {
                    //swal('ERROR', res.message, 'error');
                    let toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }
                setTimeout(() => {
                    that.hasInitialSetup = false;
                }, 10);

            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                //swal('ERROR', res.message, 'error');
                //console.log(error);
                that.toasterService.pop('ERROR', res.message, 'error');
            });
    }
    //To Check Warranty_period Date To curr Date
    warrantyCheck(date) {
        let warrentyCheckIpDate = moment(new Date()).format('YYYY-MM-DD');

        let warrentyDate = date;
        warrentyDate = warrentyDate.split("-");

        warrentyDate = new Date(warrentyDate[2], (warrentyDate[1] - 1), warrentyDate[0]);

        warrentyDate = moment(warrentyDate).format('YYYY-MM-DD');
        if (warrentyCheckIpDate <= warrentyDate) {
            return true;
        }
        else {
            return false;
        }

    }
    onSaveFollowUp() {
        let toast = {
            type: 'error',
            title: 'WARNING'
        };
        if (_.isEmpty(this.clientFollowDet['description'])) {
            toast['body'] = 'Please Write Description';
            this.toasterService.pop(toast);
            return;
        }
        if (_.isEmpty(_.toString(this.clientFollowDet['date']))) {
            toast['body'] = 'Please Select Date';
            this.toasterService.pop(toast);
            return;
        }
        if (this.clientFollowDet['fol_type'] == 'Follow Up' && !this.clientFollowDet['follow_up_willing']) {
            toast['body'] = 'Please Select Willing Status';
            this.toasterService.pop(toast);
            return;
        }
        if (this.clientFollowDet['status'] == 'SOA') {
            if (this.testingtypeCtrl['status'] != 'VALID') {
                toast['body'] = 'Please Select Valid Testing Type';
                this.toasterService.pop(toast);
                return;
            }
        }


        /*******SG-CR-13 :  For Sold machines (under warranty period) when 1 year recheck up is done in HV, next it should be routed to 2nd year recheck up in sold follow up (PROCESS ERROR) ******/

        if (this['followUpTeam'] == "HV" || this['followUpTeam'] == "SOA") {
            if (this.clientFollowDet['fol_type'] == "Not Ok" || this.clientFollowDet['fol_type'] == "Done" || this.clientFollowDet['fol_type'] == "Not Willing Now") {
                let temp_check: boolean = false;
                if (this.clientFollowDet['warranty'] == '1 Year' && this.clientFollowDet['next_oneyear_fol_disp_date']) {

                    temp_check = this.warrantyCheck(this.clientFollowDet['next_oneyear_fol_disp_date'])

                }
                else if ((!this.clientFollowDet['warranty'] || this.clientFollowDet['warranty'] == '2 Years') && this.clientFollowDet['next_twoyear_fol_disp_date']) {

                    temp_check = this.warrantyCheck(this.clientFollowDet['next_twoyear_fol_disp_date'])
                }

                else if (this.clientFollowDet['warranty'] == '2.5 Years' && this.clientFollowDet['next_twoandhalf_year_fol_disp_date']) {

                    temp_check = this.warrantyCheck(this.clientFollowDet['next_twoandhalf_year_fol_disp_date'])

                }
                if (temp_check) {
                    swal('ERROR', "Under Warranty, Route to Sold Followup!", 'error');
                    return;
                }

            }
        }
        // else if (this['followUpTeam'] == 'Sold') {
        //     if (this.clientFollowDet['fol_type'] == "Not Ok" || this.clientFollowDet['fol_type'] == "Done" || this.clientFollowDet['fol_type'] == "Not Willing Now") {
        //         let temp_check: boolean = false;
        //         if (this.clientFollowDet['warranty'] == '1 Year' && this.clientFollowDet['next_oneyear_fol_disp_date']) {

        //             temp_check = this.warrantyCheck(this.clientFollowDet['next_oneyear_fol_disp_date'])

        //         }
        //         else if ((!this.clientFollowDet['warranty'] || this.clientFollowDet['warranty'] == '2 Years') && this.clientFollowDet['next_twoyear_fol_disp_date']) {

        //             temp_check = this.warrantyCheck(this.clientFollowDet['next_twoyear_fol_disp_date'])
        //         }

        //         else if (this.clientFollowDet['warranty'] == '2.5 Years' && this.clientFollowDet['next_twoandhalf_year_fol_disp_date']) {

        //             temp_check = this.warrantyCheck(this.clientFollowDet['next_twoandhalf_year_fol_disp_date'])

        //         }

        //         if (temp_check) {
        //             swal('ERROR', "Under Warranty, Don't Close The FollowUp!", 'error');
        //             return;
        //         }
        //     }
        // }

        if (_.isEmpty(_.toString(this.clientFollowDet['status']))) {
            toast['body'] = 'Please Select Status';
            this.toasterService.pop(toast);
            return;
        }

        // Employee Name validation for Unsold followup
        if (this['followUpTeam'] == 'Unsold' || this['followUpTeam'] == 'Unsold OCT') {
            const empAssignValue = this.clientFollowDet['emp_assign'];
            console.log('Employee validation - emp_assign value:', empAssignValue, 'type:', typeof empAssignValue);

            if (!empAssignValue || empAssignValue == 0 || empAssignValue == '0' || empAssignValue == '' || empAssignValue == null || empAssignValue == undefined) {
                toast['body'] = 'Please Select Employee Name';
                this.toasterService.pop(toast);
                return;
            }
        }
        /*  if (this['followUpTeam'] == 'Unsold' || this['followUpTeam'] != 'Sales') {
              if (_.isEmpty(this.clientFollowDet['unsold_feedback'])) {
                  toast['body'] = 'Please Select FeedBack';
                  this.toasterService.pop(toast);
                  return;
              } else {
                 
              }
          } else if (this['followUpTeam'] == 'Sold') {
              if (_.isEmpty(this.clientFollowDet['sold_feedback'])) {
                  toast['body'] = 'Please Select FeedBack';
                  this.toasterService.pop(toast);
                  return;
              } else {
                 
              }
          }*/
        let model_id = '';
        if (!_.isEmpty(this.clientFollowDet['model_id'])) {
            model_id = (this.clientFollowDet['model_id']).join();
        }
        let entryDate = '';
        if (!this._followUpDet['date'] && this.clientFollowDet['entry_date']) {
            entryDate = moment(this.clientFollowDet['entry_date']).format('YYYY-MM-DD');
        }
        let that = this,
            followUpDate = moment(this.clientFollowDet['date']).format('YYYY-MM-DD'),



            hvDate = moment(this.clientFollowDet['hv_date']).format('YYYY-MM-DD'),

            soaDate = moment(this.clientFollowDet['soa_date']).format('YYYY-MM-DD'),
            data = {
                description: this.clientFollowDet['description'],
                date: followUpDate,
                act_date: this._followUpDet['act_date'],
                // hv_date: hvDate,
                // soa_date: soaDate,
                from_page: this['followUpTeam'],
                status: this.clientFollowDet['status'],
                client_id: this._followUpDet['client_id'],
                phone_no: this._followUpDet['mobile'],
                client_name: this._followUpDet['client_name'],
                st_id: this._followUpDet['st_id'],
                mode: that._followUpDet['mode'],
                smsCompany_id: this.clientFollowDet['branchSms_id'],
                fol_type: this.clientFollowDet['fol_type'],
                hv_type: this.clientFollowDet['hv_type'],
                soa_type: this.clientFollowDet['soa_type'],
                unsold_remarks: this.clientFollowDet['unsold_remarks'],
                visitor_name: this.clientFollowDet['visitor_name'],
                travel_expense: this.clientFollowDet['travel_expense'],
                empid1: this.clientFollowDet['empid1'],
                empid2: this.clientFollowDet['empid2'],
                hv_out_status: this.clientFollowDet['hv_out_status'],
                soa_out_status: this.clientFollowDet['soa_out_status'],
                company_id: this.clientFollowDet['branch_id'],
                recheckup_months: this.clientFollowDet['recheckup_months'],
                unsold_feedback: this.clientFollowDet['unsold_feedback'],
                sold_feedback: this.clientFollowDet['sold_feedback'],
                to_whom: this.clientFollowDet['to_whom'],
                relation: this.clientFollowDet['relation'],
                attender_profession: this.clientFollowDet['attender_profession'],
                name: this.clientFollowDet['name'],
                relation_age: this.clientFollowDet['relation_age'],
                ha_user: this.clientFollowDet['ha_user'],
                model_name: this.clientFollowDet['model_name'],
                dr_consulted: this.clientFollowDet['dr_consulted'],
                billing_detail: this.clientFollowDet['billing_detail'],
                free_item: this.clientFollowDet['free_item'],
                using_method: this.clientFollowDet['using_method'],
                rating: this.clientFollowDet['rating'],
                service: this.clientFollowDet['service'],
                address: this.clientFollowDet['address'],
                alt_mobile: this.clientFollowDet['alt_mobile'],
                new_branch_id: this.clientFollowDet['new_branch_id'],
                complaint: this.clientFollowDet['complaint'],
                potential_customer: this.clientFollowDet['potential_customer'],
                model_id: model_id,
                important: this.clientFollowDet['important'],
                willing: this.clientFollowDet['willing'],
                cancelled: this.clientFollowDet['cancelled'],
                col_status: this.clientFollowDet['col_status'],
                testing: this.clientFollowDet['testing'],
                assign_empid: this.clientFollowDet['assign_empid'],
                emp_assign: this.clientFollowDet['emp_assign'],
                follow_up_willing: this.clientFollowDet['follow_up_willing'] || '',
                summary_status: this.clientFollowDet['summary_status'] || '',
                communication_type: this.clientFollowDet['communication_type'] || '',
                entry_date: entryDate
            };

        if ((data.from_page == 'HV') && (data.status == '19')) {
            data['hv_date'] = hvDate;
        } else {
            data['hv_date'] = '';
        }
        if ((data.from_page == 'SOA') && (data.status == '21')) {
            data['soa_date'] = soaDate;
        } else {
            data['soa_date'] = '';
        }
        if ((data.from_page == 'AfterSales')) {
            data['unsold_feedback'] = '';
        }

        this.isLoading = true;
        this.followUpService
            .saveFollowUpDet(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal(
                        'SUCCESS',
                        res.message,
                        'success'
                    );
                    that.bsModalRef.hide();
                    that.followUpListGridUpdateEvent.emit();
                } else {
                    //that.snackBar.open(res.message);
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };

                    that.toasterService.pop(toast);
                    //swal('ERROR', res.message, 'error');
                }

            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }

    onCloseFollowUp(): void {
        let that = this,
            clientID = this._followUpDet['client_id'],
            data = {
                client_id: clientID,
                attender_status: 'close'
            };

        that.isLoading = true;
        this.followUpService
            .changeAttenderStatus(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.bsModalRef.hide();
                    //that.skuUpdateEvent.emit();
                } else {
                    swal('ERROR', res.message, 'error');
                }

            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/followUp/followUpWindow.component.ts